export default __webpack_public_path__ + "static/media/pt_split_3.0f298cf6.svg";